module.exports = __webpack_public_path__ + "static/media/fam_knol_center.d5761f14.jpg";